import { stringify } from 'src/core/hooks/use-translation'
import { boolean, object, setLocale, string } from 'yup'

setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  }
})

export default object().shape({
  active: string().notRequired(),
  automatic_approval: boolean().required(),
  code: string()
    .required()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    ),
  consensual_approval: boolean().required(),
  cost_center_approval: boolean().required(),
  description: string()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    )
    .notRequired(),
  exception_approver: boolean().required(),
  name: string()
    .required()
    .max(
      250,
      stringify('web.setup.form.field-title.max-character-error', {
        value: 250
      })
    ),
  // policy_approval_id: string().notRequired(),
  reason_approval: boolean().required()
})
